import { Zap } from "lucide-react";

const Logo = () => {
  return (
    <div className="flex items-center gap-2">
      <div className="w-8 h-8 bg-gradient-to-br from-primary to-primary-glow rounded-lg flex items-center justify-center">
        <img alt="Logo" src="/images/logo.png" className="w-full h-full object-cover" style={{ minWidth: "32px" }} />
      </div>
      <span className="text-xl font-bold text-foreground" style={{ lineHeight: "1.25rem" }}>Soderstrom Legal Documents</span>
    </div>
  );
};

export default Logo;